export const DEFAULT_ERROR_TEXTS = {
    title: 'Данные не загрузились',
    description: 'Что-то пошло не так. Попробуйте еще раз чуть позже.',
}
